/* eslint-disable camelcase */
import createUpload from '@ai/mss-upload-js';
import request from '@utils/request';
import { isProduction } from './tools';

/** 上传附件的加签接口 */
export const attachmentSignUrl = '/api/official/getPreSignedForUpload/attachment';

interface Options {
  /** 加签接口地址 */
  signUrl: string;
  /** 上传成功后获取文件信息 */
  onFileInfo?: (fileInfo: FileInfo) => void;
  /** 上传开始前回调 */
  onStart?: () => void;
  /** 上传前校验文件 */
  onValidateFile?: (fileInfo) => boolean;
  /** 上传成功后获取文件url */
  onSuccess?: (fileUrl: string) => void;
  /** 上传失败回调 */
  onError?: (errorInfo: string) => void;
  /** 获取上传进度 */
  onProgress?: (percent: number) => void;
  /** 可上传文件类型-['.zip'] */
  accept?: string[];
  /** 拖拽的文件 */
  file?: File;
}

interface SignParams {
  awsaccessKeyId: string;
  signature: string;
  policy: string;
  key: string;
}

interface FileInfo {
  key: string;
  fileName: string;
  fileType: string;
  fileSize: number;
}

/**
 * 前端直接上传文件到S3
 * @param options 设置参数
 */
const frontEndUpload = (options: Options) => {
  let uploadParams: Partial<SignParams> = {};
  const { onFileInfo, onValidateFile, onSuccess, onError, onProgress, accept, onStart, signUrl, file } = options;

  const generateParams = () => {
    const { awsaccessKeyId, signature, policy, key } = uploadParams;
    return new Promise((resolve) => {
      resolve({
        code: 0,
        message: '加签参数获取成功',
        data: {
          AWSAccessKeyId: awsaccessKeyId,
          signature,
          policy,
          key,
        },
      });
    });
  };

  const onUpload = async () => {
    const res = await request.post(signUrl);
    uploadParams = res;

    const commonOptions = {
      // 详见https://npm.sankuai.com/v2/pkg/detail?name=%40ai%2Fmss-upload-js
      signatureFunc: generateParams,
      bucket: res.bucketName, // S3bucket
      accept: accept || [], // 上传的文件类型
      prefix_type: 's3_style',
      isTest: !isProduction(),
      isHttps: true,
      file,
      onProgress(percent: number) {
        onProgress?.(percent);
      },
      onStart() {
        onStart?.();
      },
      onFileInfo(fileInfo) {
        // 多文件上传时传入的是file[]
        onFileInfo?.(fileInfo);
      },
      validateFile(fileInfo) {
        // 多文件上传时传入的是file[]
        // 返回值为true:继续上传流程； false: 终止上传流程
        return onValidateFile ? onValidateFile(fileInfo) : true;
      },
      onSuccess(fileUrl: string) {
        onSuccess?.(fileUrl);
      },
      onError(errorMsg: string) {
        onError?.(errorMsg);
      },
    };

    // 1——单文件上传，目前仅实现这一种
    const uploadInstance = createUpload(commonOptions, 1);

    uploadInstance.upload();
  };

  onUpload();
};

export default frontEndUpload;
